// Mixin da seleção de aba dos modais de upload (itens 2/3; fixes B2/B3).
//
// Contrato do componente consumidor:
// - data: selectedTab, tabsInformations, sheetTabCandidates (nomes esperados
//   da aba do módulo — ver *_SHEET_TAB_NAMES em column-auto-match)
// - computed: tabs (nomes das abas do arquivo verificado)
// - methods: reset() (limpa binds + form) e applyAutoMatch() (auto-
//   identificação de colunas; opcional, chamado só se definido)
import { matchSheetTab } from '@/helpers/column-auto-match'

const uploadTabSelectionMixin = {
  data() {
    return {
      // B2 — distingue escolha manual (select da UI) da auto-seleção:
      // trocar de opção NUNCA troca silenciosamente uma aba escolhida
      // manualmente pelo usuário
      tabSelectionIsManual: false,
      // B3 — re-monta o select de aba a cada limpeza (:key no template):
      // quando a aba re-selecionada é a MESMA, a prop selectedItem não muda
      // e o v-autocomplete esvaziado pelo form.reset() não re-sincroniza
      tabSelectKey: 0,
    }
  },
  methods: {
    setSelectedTab(value) {
      this.selectedTab = value
      this.tabsInformations.tab.name = value
    },
    // caminho da UI (select de aba)
    handleTabSelection({ value }) {
      this.tabSelectionIsManual = true
      this.setSelectedTab(value)
    },
    // Auto-seleção da aba (item 2): se uma aba do arquivo casa com o nome
    // esperado do módulo, seleciona sem intervenção do usuário
    autoSelectTab() {
      const matched = matchSheetTab(this.tabs, this.sheetTabCandidates)
      if (!matched) return
      this.tabSelectionIsManual = false
      this.setSelectedTab(matched)
      // Cobre a re-seleção da MESMA aba: o watch de selectedTab não dispara
      // (valor final igual) e o auto-match precisa rodar aqui. Quando a aba
      // muda de fato, o watch re-executa reset() + applyAutoMatch() com
      // resultado idêntico. Os 3 modais (people, groups e occupations)
      // definem applyAutoMatch — o guard mantém o mixin reusável por um
      // modal futuro sem auto-match de colunas.
      if (typeof this.applyAutoMatch === 'function') this.applyAutoMatch()
    },
    clearTabSelection() {
      this.reset()
      this.setSelectedTab('')
      this.tabSelectionIsManual = false
      this.tabSelectKey += 1 // B3 — força re-mount do select de aba
    },
    // Pós-upload: arquivo NOVO — escolha manual do arquivo anterior não
    // vale mais; limpa e re-auto-seleciona sempre
    resetTabSelectionForNewFile() {
      this.clearTabSelection()
      this.autoSelectTab()
    },
    // Troca de opção (item 3 + B2): sempre limpa binds e aba; re-auto-
    // seleciona apenas quando a aba anterior era auto-selecionada (ou igual
    // à candidata do match) — escolha MANUAL divergente fica VAZIA para o
    // usuário re-escolher explicitamente (sem troca silenciosa, perigoso
    // com delete)
    resetTabSelectionForOptionChange() {
      const previousTab = this.selectedTab
      const wasManual = this.tabSelectionIsManual
      const candidate = matchSheetTab(this.tabs, this.sheetTabCandidates)

      this.clearTabSelection()

      if (wasManual && previousTab && previousTab !== candidate) return
      this.autoSelectTab()
    },
  },
}

export { uploadTabSelectionMixin }
